// extracted by mini-css-extract-plugin
export default {"approvalLoader":"OnboardingApprovalViewer_approvalLoader__4pKGI"};